import { useCallback, useState } from "react";
import { useFormContext } from "react-hook-form";
import AgricultureOutlinedIcon from '@mui/icons-material/AgricultureOutlined';
import DisplayListPropriedades from "./DisplayListPropriedades";
import DialogFormDadosPropriedade from "./DialogFormDadosPropriedade";
import moment from "moment";

export default function DadosPropriedade() {

    const { getValues, watch, setValue, formState: { errors }, clearErrors } = useFormContext();

    const [openModal, setOpenModal] = useState<TOpenModalPropriedade>(null)

    //funções manipuladoras
    const handleModalAction = useCallback((action: "open" | "close", index?: number | null, value?: TDadosPropriedade | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && typeof index === "number" && value) {setOpenModal({ open: true, index, defaultValue: value })}
        if (action === "open" && !index && !value) setOpenModal({ open: true, index: null, defaultValue: null })
    }, [])
    //

    const propriedades: TDadosPropriedade[] = watch("dadosProp") || [];
    const handleAdicionarPropriedade = (data: TDadosPropriedade) => {
        const currentPropriedades = getValues("dadosProp") || [];
        const updatedPropriedades: TDadosPropriedade[] = [...currentPropriedades, data];
        setValue("dadosProp", updatedPropriedades);
        clearErrors("dadosProp");
        handleModalAction("close");
    }

    const handleEditarPropriedade = (index: number, item: TDadosPropriedade) => {
        const currentPropriedades = getValues("dadosProp") || [];
        const updatedPropriedades: TDadosPropriedade[] = currentPropriedades.map((prop: TDadosPropriedade, i: number): TDadosPropriedade => i === index ? item : prop);
        setValue("dadosProp", updatedPropriedades);
        handleModalAction("close");
    }

    const handleDeletePropriedade = (index: number) => {
        const currentPropriedades = getValues("dadosProp") || [];
        const updatedPropriedades: TDadosPropriedade[] = currentPropriedades.filter((_: TDadosPropriedade, i: number) => i !== index);
        setValue("dadosProp", updatedPropriedades);
    }

    return (
        <>
            <DisplayListPropriedades
                items={propriedades}
                handleOpenDialog={() => {
                    handleModalAction("open", undefined, null)
                }}
                handleDeleteItem={handleDeletePropriedade}
                handleEditItem={(item, index) => {
                    handleModalAction("open", index, item);
                }}
                emptyListMessage="Nenhuma fazenda adicionada"
                linkButtonText="Adicionar fazenda"
                linkButtonIcon={
                    <AgricultureOutlinedIcon sx={{ color: "#1b5e20" }} />
                }
                errorMessage={errors?.dadosProp ? (errors.dadosProp.message as string) : undefined}
            />
            {
                Boolean(openModal?.open) &&
                <DialogFormDadosPropriedade
                    defaultValue={openModal?.defaultValue ? openModal : null}
                    open={Boolean(openModal?.open)}
                    onClose={() => handleModalAction("close")}
                    onSubmit={(data) => {
                        if (typeof openModal?.index === "number") {
                            handleEditarPropriedade(openModal?.index, data);
                            return;
                        }
                        handleAdicionarPropriedade(data);
                    }}
                />
            }
        </>
    )
}

export type TOpenModalPropriedade = {
    open: boolean | null;
    index: number | null;
    defaultValue: TDadosPropriedade | null;
} | null

export type TDadosPropriedade = {
    nome: string;
    propriaProp: "Sim" | "Não";
    tamanho: string;
    arrendatario: "Sim" | "Não";
    vencimentoContrato: moment.Moment;
    leite: {
        produtor: "Sim" | "Não";
        mediaDiaria: string;
        qtdVacas: string;
        valor: string;
    };
    cafe: {
        produtor: "Sim" | "Não";
        qtdSacas: string;
        qtdHa: string;
        valor: string;
    };
    milho: {
        produtor: "Sim" | "Não";
        qtdSacas: string;
        qtdHa: string;
        valor: string;
    };
    soja: {
        produtor: "Sim" | "Não";
        qtdSacas: string;
        qtdHa: string;
        valor: string;
    };
    gadoCorte: {
        produtor: "Sim" | "Não";
        qtdCabecas: string;
        raca: string;
        valor: string;
    };
    outraCultura: {
        produtor: "Sim" | "Não";
        nome: string;
        producaoEstimada: string;
        valor: string;
    };
    outraRenda: {
        produtor: "Sim" | "Não";
        nome: string;
        valor: string;
    };
};
